export default "__VITE_ASSET__DpjLw1EH__"